import type { RecordSectionSet } from './types';

/**
 * Sections valid for a record that does not exist on the server yet. Each
 * excluded one is entity-scoped (enabled on `!!entityId`), so leaving it on
 * would mean network traffic for an id the server has never seen — a research
 * poll, a files fetch, a timeline query. Shared by builder mode and the
 * slideout preview so both suppress exactly the same set.
 */
export const UNSAVED_SECTIONS: Partial<RecordSectionSet> = {
  notes: false,
  tasks: false,
  files: false,
  research: false,
  timeline: false,
};

// `typeSpecific` is deliberately NOT disabled here. It is a per-entity-type
// slot, and the two kinds of section that occupy it differ:
//   - Server list queries keyed on the record's id (a contact's "Upcoming
//     meetings" / "Meeting notes") cannot resolve for an unsaved record.
//     `RelatedEntitySection` skips its own fetch and renders nothing when the
//     draft is unsaved, so the gate lives with the query that needs it.
//   - Sections reading the record's OWN data (a company's People list, via
//     `object.associations`) project perfectly well and MUST keep rendering —
//     a proposal that creates a company and a contact should show that contact
//     on the projected company.
// Blanket-disabling the slot would take the second kind down with the first.
